import { render, staticRenderFns } from "./BillingCodes.vue?vue&type=template&id=f96e5f4c&scoped=true"
import script from "./BillingCodes.vue?vue&type=script&lang=js"
export * from "./BillingCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96e5f4c",
  null
  
)

export default component.exports